import axios from "axios";
import { getBearerToken, handleSessionExpired } from "../utils/sessionAuth";

const createHttp = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
	headers: {
		"Content-Type": "application/json",
		Accept: "application/json",
	},
});

const isHandlerEnabled = (config = {}) => {
	return !(config.hasOwnProperty("handlerEnabled") && !config.handlerEnabled);
};

createHttp.interceptors.request.use((config) => {
	const token = getBearerToken();
	if (token) {
		config.headers.Authorization = `Bearer ${token}`;
	}
	try {
		const lang = localStorage.getItem("lang") || "en";
		config.headers["Accept-Language"] = lang;
	} catch {
		/* ignore */
	}
	return config;
});

const errorHandler = (error) => {
	if (isHandlerEnabled(error.config)) {
		if (error.response?.status === 401) {
			handleSessionExpired();
		}
		if (error.response?.status === 403 && error.response?.data?.code) {
			window.dispatchEvent(new CustomEvent('t4-access-denied', { detail: error.response.data }));
		}
	}

	return error.response;
};

const successHandler = (response) => {
	if (response?.status === 401) {
		handleSessionExpired();
	}
	return response;
};

createHttp.interceptors.response.use(
	(response) => successHandler(response),
	(error) => errorHandler(error),
);

export default createHttp;
